import { Notification, NotificationType } from '@components/NotificationProvider';

export interface ResultArray {
    errors: ResultMessage[],
    messages: ResultMessage[],
    criticals: ResultMessage[],
    warnings: ResultMessage[]
}
export interface ResultMessage {
    code: string,
    description: string[]
}

export const getPageTitle = () => {
    return window.location.pathname
        .split('/')[1]
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
        .join(' ');
}

export function HandleGenericErrors(error: any, addNotifications: Function) {
    let result = {} as ResultArray;

    const handleMessageArray = (messages: any[], notificationType: NotificationType) => {
        let handleMessageArrayResult = new Array<ResultMessage>();
        let notifications = new Array<Notification>();
        let time = Date.now();

        messages.forEach((resultMessage: any) => {
            handleMessageArrayResult.push({ code: resultMessage.code, description: [resultMessage.description] });
            notifications.push({
                text: resultMessage.description,
                page: getPageTitle(),
                type: notificationType,
                time: time
            });
        });
        if (notifications.length > 0) {
            addNotifications(notifications);
        }
        return handleMessageArrayResult;
    }

    function ExtractMessagesFromModel(model: any, notificationType: NotificationType) {
        let objectArray = Object.entries(model);

        let extractMessagesFromModelResult = new Array<ResultMessage>();
        let notifications = new Array<Notification>();
        let time = Date.now();

        objectArray.forEach(message => {
            let notificationArray = message[1] as any;
            let description = notificationArray.errors ? notificationArray.errors : notificationArray;
            if (Array.isArray(description)) {
                description = description[0];
            }
            extractMessagesFromModelResult.push({ code: message[0], description: description });
            notifications.push({
                text: description,
                page: getPageTitle(),
                type: notificationType,
                time: time
            });
        });

        if (notifications.length > 0) {
            addNotifications(notifications);
        }
        return extractMessagesFromModelResult;
    }

    function handleNotificationsFor(errorNotifications: any[], notificationType: NotificationType) {
        if (errorNotifications) {
            if (errorNotifications.length) {
                return handleMessageArray(errorNotifications, notificationType);
            } else {
                return ExtractMessagesFromModel(errorNotifications, notificationType);
            }
        }
        return new Array<ResultMessage>();
    }

    result.messages = handleNotificationsFor(error.messages, 'info');
    result.warnings = handleNotificationsFor(error.warnings, 'warning');
    result.errors = handleNotificationsFor(error.errors, 'error');
    result.criticals = handleNotificationsFor(error.criticals, 'error');

    if (error.status === 401) {
        addNotifications([{
            text: 'You are not authorized. Please try log out and back in.',
            page: getPageTitle(),
            type: 'error',
            time: Date.now()
        }], getPageTitle(), 'error');
    } else if (error.status === 403) {
        addNotifications([{
            text: 'You do not have access to perfrom this action.',
            page: getPageTitle(),
            type: 'error',
            time: Date.now()
        }], getPageTitle(), 'error');
    } else if (error.status === 500) {
        addNotifications([{
            text: 'There was an error with the message.',
            page: getPageTitle(),
            type: 'error',
            time: Date.now()
        }], getPageTitle(), 'error');
    }

    return result;
}